export const EPIC_ISSUE_TYPE_NAME = 'Epic' as const;
